import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Mail, MapPin, Phone, Linkedin, Twitter, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-background border-t border-white/10 pt-20 pb-10" data-id="element-85">
      <div className="container mx-auto px-6" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-87">
          <div className="space-y-6" data-id="element-88">
            <img src="https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/footer-logo.png" alt="CRS Logo" className="h-12 w-auto" data-id="element-89" />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs" data-id="element-90">
              North America's premier cybersecurity academy, empowering the next
              generation of security leaders through immersive, industry-aligned
              training.
            </p>
            <div className="flex gap-4" data-id="element-91">
              {[{
              icon: Linkedin,
              href: '#'
            }, {
              icon: Twitter,
              href: '#'
            }, {
              icon: Instagram,
              href: '#'
            }, {
              icon: Youtube,
              href: '#'
            }].map((social, i) => <a key={i} href={social.href} className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:text-primary-blue hover:border-primary-blue transition-all" data-id="element-92">
                  <social.icon size={18} data-id="element-93" />
                </a>)}
            </div>
          </div>

          <div data-id="element-94">
            <h4 className="text-white font-bold mb-6" data-id="element-95">Training Programs</h4>
            <ul className="space-y-4" data-id="element-96">
              {['Cybersecurity 101', 'GRC Masterclass', 'Data Privacy', 'Risk Management', 'Executive Protection', 'Healthcare Compliance'].map(item => <li key={item} data-id="element-97">
                  <a href="#" className="text-white/50 text-sm hover:text-primary-blue transition-colors" data-id="element-98">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-99">
            <h4 className="text-white font-bold mb-6" data-id="element-100">Resources</h4>
            <ul className="space-y-4" data-id="element-101">
              {['Student Portal', 'Career Support', 'Blog & News', 'Certification Prep', 'Global Alumni', 'Apply Now'].map(item => <li key={item} data-id="element-102">
                  <a href="#" className="text-white/50 text-sm hover:text-primary-blue transition-colors" data-id="element-103">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-104">
            <h4 className="text-white font-bold mb-6" data-id="element-105">Contact Us</h4>
            <ul className="space-y-4" data-id="element-106">
              <li className="flex items-start gap-3 text-white/50 text-sm" data-id="element-107">
                <MapPin size={18} className="text-primary-blue shrink-0" data-id="element-108" />
                <span data-id="element-109">
                  North America Headquarters
                  <br data-id="element-110" />
                  123 Security Plaza, Tech City
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/50 text-sm" data-id="element-111">
                <Phone size={18} className="text-primary-blue shrink-0" data-id="element-112" />
                <span data-id="element-113">+1 (800) 123-4567</span>
              </li>
              <li className="flex items-center gap-3 text-white/50 text-sm" data-id="element-114">
                <Mail size={18} className="text-primary-blue shrink-0" data-id="element-115" />
                <span data-id="element-116">info@cyberreadysecurity.com</span>
              </li>
            </ul>

            <div className="mt-8" data-id="element-117">
              <div className="relative" data-id="element-118">
                <input type="email" placeholder="Join our newsletter" className="w-full bg-white/5 border border-white/10 rounded-full py-3 px-6 text-sm text-white focus:outline-none focus:border-primary-blue transition-colors" data-id="element-119" />
                <button className="absolute right-1.5 top-1.5 w-10 h-10 rounded-full bg-primary-blue flex items-center justify-center text-white hover:bg-blue-600 transition-colors" data-id="element-120">
                  <ArrowRight size={18} data-id="element-121" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-122">
          <div className="text-white/30 text-xs" data-id="element-123">
            © {currentYear} Cyber Ready Security. All rights reserved.
          </div>
          <div className="flex gap-8" data-id="element-124">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map(item => <a key={item} href="#" className="text-white/30 text-xs hover:text-white transition-colors" data-id="element-125">
                  {item}
                </a>)}
          </div>
        </div>
      </div>
    </footer>;
}